/**
 * Centralized configuration for the Wizard UI
 */

// API endpoints
export const API_CONFIG = {
  // Base API endpoint, can be overridden with VITE_API_URL environment variable
  API_BASE_URL: import.meta.env.VITE_API_URL || 'https://buildswarm-api.speedppc.workers.dev',
  
  // R2 storage endpoint for files, screenshots, and early URL data
  R2_BASE_URL: 'https://buildswarm-r2.speedppc.workers.dev',
  
  // Other worker URLs
  PAGE_WORKER_URL: 'https://buildswarm-page.speedppc.workers.dev',
  AI_WORKER_URL: 'https://buildswarm-ai.speedppc.workers.dev',

  // URL patterns for early and complete URL data
  EARLY_URLS_PATTERN: (requestId: string, hostname: string) => 
    `https://buildswarm-r2.speedppc.workers.dev/early-urls/${requestId}_${hostname.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.json`,
  
  COMPLETE_URLS_PATTERN: (requestId: string, hostname: string) => 
    `https://buildswarm-r2.speedppc.workers.dev/urls/${requestId}_${hostname.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.json`
};

// UI Settings
export const UI_CONFIG = {
  // Default API key (for development only)
  DEFAULT_API_KEY: 'dev-api-key-1234',
  
  // Poll interval for status updates (in milliseconds)
  STATUS_POLL_INTERVAL: 2000,
  
  // Maximum poll time before timing out (in milliseconds)
  MAX_POLL_TIME: 2 * 60 * 1000, // 2 minutes
  
  // Local storage keys
  STORAGE_KEYS: {
    API_KEY: 'buildswarm_api_key',
    HISTORY: 'buildswarm_history',
    THEME: 'buildswarm_theme'
  }
}; 